export const TUTORIALS_LOCAL_STORAGE_KEY_PREFIX = "isHelpBtnWasShown";
